import { toLtvPercentage } from 'containers/pages/Dashboard/utils/cryptoUtils';

/** Margin call / liquidation / contractual LTV thresholds from GET /qpay/loans/{loanId}/setup. */
export const getQuickpayLoanSetupThresholds = (setupData) => {
  if (!setupData) {
    return { marginCallPct: null, liquidationPct: null, contractualLtvPct: null };
  }

  return {
    marginCallPct: toLtvPercentage(setupData.marginCallLtv ?? null),
    liquidationPct: toLtvPercentage(setupData.liquidationLtv ?? null),
    contractualLtvPct: toLtvPercentage(setupData.loanToValue ?? null),
  };
};
